function Preloader()
{
    return(<div className="center"><p className="m-auto" ><i className="fas fa-circle-notch fa-spin text-5xl"></i></p></div>)
}

export default Preloader;